import { render, staticRenderFns } from "./UniIcon.vue?vue&type=template&id=0e422abe&scoped=true&"
import script from "./UniIcon.vue?vue&type=script&lang=js&"
export * from "./UniIcon.vue?vue&type=script&lang=js&"
import style0 from "./UniIcon.vue?vue&type=style&index=0&id=0e422abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e422abe",
  null
  
)

export default component.exports